/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edu-radio-btn[_ngcontent-%COMP%]{margin:3px}.mat-radio-checked[_ngcontent-%COMP%]     .mat-radio-outer-circle{border-color:#75ba1d!important}  .mat-radio-inner-circle{background-color:#75ba1d!important}  .mat-radio-ripple .mat-ripple-element{background-color:rgba(117,186,29,.26)!important}"];
export { styles as styles };
